import uploadResourcesAndDispatchEvent from '../../../calcs/common/helpers/resource-loading/upload-resources-and-dispatch-event'
;(function() {
    const domen = 'https://euro-ins.ru',
        css = [
            {
                url:
                    '/front/dist/js/calc/cargo/main/vendors-b8e63563957dc91c2c92.css',
                loaded: false,
            },
            {
                url:
                    '/front/dist/js/calc/cargo/main/index-4f9548e541a336a07565.css',
                loaded: false,
            },
        ],
        js = [
            {
                url:
                    '/front/dist/js/calc/cargo/main/runtime-d78e2f6a5e794cff7782.v2.js',
                loaded: false,
            },
            {
                url:
                    '/front/dist/js/calc/cargo/main/vendors-b8e63563957dc91c2c92.v2.js',
                loaded: false,
            },
            {
                url:
                    '/front/dist/js/calc/cargo/main/index-4f9548e541a336a07565.v3.js',
                loaded: false,
            },
        ]
    uploadResourcesAndDispatchEvent(css, js, domen)
})()